export enum EnumTimeCheck {
  '開' = '1',
  '關' = '0',
}

export enum EnumDeclType {
  '進口' = '1',
  '出口' = '2',
}
